<template>
  <div class="page-root">
    <h1 style="font-family: maplestory">애셋 스토어</h1>
    <div class="app-page__content mt-4 pa-4">
      <v-alert color="#9575CD" dark icon="mdi-wrench" border="left">
        애셋들을 조합해서 나만의 감정표현과 리액션을 만들어보세요!
      </v-alert>
      <v-tabs v-model="selected.tabIndex" background-color="transparent" color="primary lighten-1">
        <v-tab>캐릭터</v-tab>
        <!-- <v-tab>애니메이션</v-tab> -->
        <v-tab>악세사리</v-tab>
        <v-tab>이펙트</v-tab>
        <!-- <v-tab>배경</v-tab> -->
        <v-tab>자막효과</v-tab>
        <v-tab>효과음</v-tab>
      </v-tabs>
      <div></div>
      <v-tabs-items class="mt-6" v-model="selected.tabIndex" style="background-color: transparent">
        <v-tab-item>
          <CharacterTab></CharacterTab>
        </v-tab-item>
        <v-tab-item>
          <AccessoriesTab></AccessoriesTab>
        </v-tab-item>
        <v-tab-item>
          <EffectTab></EffectTab>
        </v-tab-item>
        <v-tab-item>
          <TextEffectTab></TextEffectTab>
        </v-tab-item>
        <v-tab-item>
          <SoundEffectTab></SoundEffectTab>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import AccessoriesTab from "./-components/AccessoriesTab.vue";
import CharacterTab from "./-components/CharacterTab.vue";
import EffectTab from "./-components/EffectTab.vue";
import SoundEffectTab from "./-components/SoundEffectTab.vue";
import TextEffectTab from "./-components/TextEffectTab.vue";

export default {
  components: {
    TextEffectTab,
    AccessoriesTab,
    CharacterTab,
    EffectTab,
    SoundEffectTab,
  },
  data() {
    return {
      selected: {
        tabIndex: 0,
      },
    };
  },
};
</script>

<style></style>
